// eslint-disable-next-line import/prefer-default-export
import memoizeArguments from '../../../utils/memoizeArguments';

export const meetingsSelector = (state) => state.meetings.meetings;

export const meetingByIdSelector = memoizeArguments((id) => {
  return (state) => state.meetings.meetings.find((meeting) => meeting.id === id);
});
